import get from 'lodash/get';
import siteData from './site_data_util';
import baseSeoUtil from './base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData[site] || {};
  const year = get(state, 'innovationByDesign.year');
  const img = `https://a.fastcompany.net/multisite_files/fastcompany/imagecache/w/500/h/400/scale/ibd/ibd-${year}-logo-share.png`;

  return baseSeoUtil({
    site,
    siteConf,
    title: `Innovation by Design Awards ${year}`,
    url: `https://www.fastcodesign.com/innovation-by-design/${year}`,
    description: `Check out the ${year} Innovation by Design Awards.`,
    image: img,
    articleSection: 'Innovation By Design Awards'
  });
}



// WEBPACK FOOTER //
// ./src/utils/seo_utils/ibd_year_page_seo_util.js